export const DESKTOP_APP_WIDTH = 1024

export const isDesktop = window.innerWidth >= DESKTOP_APP_WIDTH
